// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/data-connect';
import { ɵzoneWrap } from '@angular/fire';
import {
  connectDataConnectEmulator as _connectDataConnectEmulator,
  executeMutation as _executeMutation,
  executeQuery as _executeQuery,
  getDataConnect as _getDataConnect,
  mutationRef as _mutationRef,
  queryRef as _queryRef,
  setLogLevel as _setLogLevel,
  subscribe as _subscribe,
  terminate as _terminate,
  toQueryRef as _toQueryRef
} from 'firebase/data-connect';

export const connectDataConnectEmulator = ɵzoneWrap(_connectDataConnectEmulator, true);
export const executeMutation = ɵzoneWrap(_executeMutation, true);
export const executeQuery = ɵzoneWrap(_executeQuery, true);
export const getDataConnect = ɵzoneWrap(_getDataConnect, true);
export const mutationRef = ɵzoneWrap(_mutationRef, true, 2);
export const queryRef = ɵzoneWrap(_queryRef, true, 2);
export const setLogLevel = ɵzoneWrap(_setLogLevel, true);
export const subscribe = ɵzoneWrap(_subscribe, true);
export const terminate = ɵzoneWrap(_terminate, true);
export const toQueryRef = ɵzoneWrap(_toQueryRef, true, 2);
